<template>
  <div class="content-wrapper">
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <app-breadcrumb
          :page-title="$t('send_proposal')"
          :directory="[$t('proposals'), $t('send_proposal')]"
          :icon="'hexagon'"
          :button="{ label: $t('back') }"
        />
      </div>
    </div>

    <form ref="form" v-if="dataLoaded" :data-url="submitUrl">
      <div
        class="card border-0 card-with-shadow"
        :class="{ 'loading-opacity': !editorShow }"
      >
        <app-overlay-loader v-if="!editorShow" />
        <div class="card-body">
          <div class="form-group mb-0">
            <div class="form-row">
              <div class="col-lg-9 col-xl-9">
                <div class="form-group row">
                  <div class="col-lg-2 col-xl-2 d-flex align-items-center">
                    <label class="mb-lg-0">{{ $t("proposal_title") }}</label>
                  </div>
                  <div class="col-lg-10 col-xl-10">
                    <div>
                      <app-input
                        type="text"
                        :placeholder="$t('type_your_proposal_title')"
                        :required="true"
                        v-model="formData.subject"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-lg-3 col-xl-3 d-flex h-100 align-items-center justify-content-lg-end"
              >
                <button
                  type="button"
                  class="btn btn-primary btn-with-shadow"
                  data-toggle="modal"
                  @click="isChooseProposalModal = true"
                >
                  {{ $t("choose_template") }}
                </button>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="form-row">
              <div class="col-lg-9 col-xl-9">
                <div class="form-group row mb-2">
                  <div class="col-lg-2 col-xl-2 d-flex align-items-center">
                    <label>{{ $t("deal_title") }}</label>
                  </div>
                  <div class="col-lg-10 col-xl-10">
                    <div class="mb-2">
                      <app-input
                        type="select"
                        list-value-field="title"
                        :list="dealList"
                        @input="selectedDeal"
                        v-model="formData.deal_id"
                      />
                    </div>
                  </div>
                </div>
                  <div class="form-group row">
                      <div class="col-lg-2 col-xl-2 d-flex align-items-center">
                      </div>
                      <div class="col-lg-10 col-xl-10">
                        <template v-if="deal">
                          <template v-if="!deal.person || !deal.person.email[0]">
                              <template v-if="!deal.person">
                                  <app-note title="'send'" padding-class="p-2" :show-title="false" :notes="[$t('the_deal_has_no_contact_person_with_email')]"/>
                              </template>
                              <template v-else>
                                  <app-note title="'send'" padding-class="p-2" :show-title="false" content-type="html" :notes='noteMessage'/>
                              </template>
                          </template>
                        </template>
                           <template v-else>
                                  <app-note title="'send'" padding-class="p-2" :show-title="false" content-type="html" :notes="[$t('no_deal','There is no deal')]"/>
                            </template>
                      </div>
                  </div>

              </div>
              <div class="col-lg-3 col-xl-3"></div>
            </div>
          </div>

          <div class="form-group">
            <div class="form-row">
              <div class="col-sm-12">
                <app-input
                  v-if="editorShow"
                  type="text-editor"
                  :required="true"
                  v-model="formData.content"
                />
              </div>
            </div>
          </div>

          <button
            type="button"
            class="btn btn-primary"
            @click.prevent="sendProposal"
            :disabled="!deal || !deal.person || !deal.person.email[0]"
          >
            <span class="w-100">
              <app-submit-button-loader
                v-if="loading"
              ></app-submit-button-loader>
            </span>
            <template v-if="!loading">{{ $t("send_proposal") }}</template>
          </button>
          <button
            type="button"
            class="btn btn-secondary mr-2"
            data-dismiss="modal"
            onclick="window.history.back()"
          >
            {{ $t("cancel") }}
          </button>
        </div>
      </div>
    </form>

    <app-overlay-loader v-else />

    <app-choose-template-modal
      v-if="isChooseProposalModal"
      :table-id="tableId"
      :modalId="tableId"
      @selected="setContent"
      @close="isChooseProposalModal = false"
    />
  </div>
</template>

<script>
import { FormMixin } from "@core/mixins/form/FormMixin";
import { api } from "@app/Helpers/api";
import { collect } from "@app/Helpers/Collection";
import {urlGenerator} from "@app/Helpers/helpers";

export default {
  props: ["selectedUrl", "action"],
  name: "SendProposal",
  mixins: [FormMixin],
  data() {
    return {
      formData: {
        deal_id: "",
      },
      dealList: [],
      isEditState: "",
      deal: {},
      loading: false,
      dataLoaded: false,
      editorShow: false,
      isChooseProposalModal: false,
      tableId: "proposal-choose-modal",
      textEditorReboot: false,
    };
  },
  computed: {
      noteMessage() {
          let url = urlGenerator(`crm/persons/${this.deal.person.id}/edit`);
          return `
            ${this.$t("the_contact")}
            <a class="alert-link" href="${url}">
                ${this.deal.person.name}
            </a>
            ${this.$t("belongs_to_the_deal_has_no_email")}
        `;
      },
    submitUrl() {
      if (this.action) {
        if (this.action === "copy") {
          this.isEditState = "post";
          return "crm/proposals";
        }
      } else {
        if (this.selectedUrl) {
          this.isEditState = "patch";
          return this.selectedUrl;
        } else {
          this.isEditState = "post";
          return "crm/proposals";
        }
      }
    },
    isCreateState() {
      return !Boolean(this.selectedUrl);
    },
  },
  methods: {
    selectedDeal() {
      this.deal = this.dealList.find((v) => v.id == this.formData.deal_id);
    },
    setContent(template) {
      const content = this.getTemplateContent(template);
      if (content !== this.formData.content) {
        this.formData.content = content;
        this.editorShow = false;
        setTimeout(() => {
          this.editorShow = true;
        }, 1500);
      }
    },
    getTemplateContent(data) {
      if (data.custom_content) return data.custom_content;
      return data.default_content;
    },
    beforeSubmit() {
      this.loading = true;
    },
    sendProposal() {
      this.formData.custom_content = this.formData.content;
      this.$store.getters.setProposalDealId
        ? this.axiosPost({
            url: `crm/send-deal-person-proposal`,
            data: {
              subject: this.formData.subject,
              deal_id: this.formData.deal_id,
              custom_content: this.formData.content,
              status_id: this.formData.status_id,
            },
          }).then((response) => {
            this.afterSuccess(response);
            this.$store.dispatch("clearDealID");
          })
        : this.submitFromFixin(this.isEditState, this.submitUrl, this.formData);
    },
    getStatus() {
      api
        .route("crm/statuses")
        .params({ name: "status_sent", type: "proposal" })
        .get("id")
        .then((res) => {
          this.formData.status_id = collect(res).first().id;
        });
    },
    getOwner() {
      return (this.formData.owner_id = null);
    },
    afterError(response) {
      this.loading = false;
      if (response) {
        if (response.data.errors) {
          this.$toastr.e(response.data.message);
        }
      }
    },
    afterSuccess(response) {
      this.loading = false;
      if (this.isCreateState) {
        this.formData = {};
      }
      if (response.data.message) {
        this.$toastr.s(response.data.message);
      } else {
        this.$toastr.e(response.data.error);
      }
      window.location.replace(urlGenerator("/crm/proposals/list/view"));
      this.$hub.$emit("reload-" + this.tableId);
    },
    afterFinalResponse() {
      this.loading = false;
      this.formData = "";
    },
    afterSuccessFromGetEditData(response) {
      let instance = this;
      instance.formData = response.data;
      this.formData.deal_id
        ? this.formData.deal_id
        : (this.formData.deal_id = 1);
      $("#note").summernote({
        callbacks: {
          onChange: function() {
            let code = $(this).summernote("code");
            if (instance.formData.content) {
              instance.formData.content = code;
            }
          },
        },
      });
    },
    openModal() {
      let instance = this;
      instance.isChooseProposalModal = true;
      setTimeout(function() {
        $("#proposal-choose-modal").modal("show");
      });
    },
    closeModal() {
      this.isChooseProposalModal = false;
      $("#proposal-choose-modal").modal("hide");
    },
    getDeals() {
      this.axiosGet("crm/deals?all")
        .then((response) => {
          this.dealList = response.data;
          this.formData.deal_id = this.dealList[0]?.id
            ? this.dealList[0]?.id
            : "";
          this.dataLoaded = true;
          this.selectedDeal();
        })
        .finally(() => {
          if (this.$store.getters.setProposalDealId)
            this.formData.deal_id = this.$store.getters.setProposalDealId;
          setTimeout(() => {
            this.editorShow = true;
          }, 1500);
        });
    },
  },
  mounted() {
    let instance = this;
    instance.getDeals();
    if (!this.formData.status_id) {
      this.getStatus();
    }
    if (!this.formData.owner_id) {
      this.getOwner();
    }
    $("#proposal-choose-modal").on("hidden.bs.modal", function(e) {
      instance.isChooseProposalModal = false;
    });
  },
};
</script>
